import React, { memo } from "react";

import { Flex, IFlexProps } from "../Flex";

const ColumnBase: React.FC<
  Omit<IFlexProps, "direction"> & React.RefAttributes<HTMLDivElement>
> = (props) => {
  return (
    <Flex
      {...props}
      // HACK: Column shouldn't accept direction, but it's passed by builder.io and possibly other sources. Support it for now.
      direction={(props as unknown as IFlexProps).direction ?? "column"}
    />
  );
};

/**
 * @trackcomponent
 */
export const Column = memo(ColumnBase);
